import React, { useState } from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { M8BillRow } from 'services/production/types';
import { TextComponent } from 'design/text/textComponents';
import {
  SmallTableExtraComponent,
  SmallTableRowComponent,
} from 'design/smallTable';
import { ClickControlComponent } from 'design/clickControl/clickControlComponents';
import { DialogComponent } from 'design/dialog';
import { GridContainerComponent } from 'design/grid';
import { ParagraphComponent } from 'design/paragraph';
import { ModalPressControlComponent } from 'design/modalPressControl';

type Props = {
  m8BillRow: M8BillRow;
  onEditRefund(refundId: number): void;
  onManageBill(billId: number): void;
  onPayDebit(debitId: number): void;
  onManageCardPayment(paymentId: number): void;
  onManageGiroPayment(paymentId: number): void;
};

export const ClientDetailsBillRow = (props: Props) => {
  const {
    m8BillRow,
    onEditRefund,
    onManageBill,
    onPayDebit,
    onManageCardPayment,
    onManageGiroPayment,
  } = props;

  const {
    clientDetailsBillRow: dictionary,
    shared: sharedDictionary,
  } = useIntlDictionary();

  const [
    payDebitConfirmationDialogIsShown,
    setPayDebitConfirmationDialogIsShown,
  ] = useState(false);

  const primaryAmountText = dictionary.primaryAmountText(m8BillRow);

  const titleText = dictionary.titleText(m8BillRow);

  const dateText = sharedDictionary.dates.calendarDateWithTime(
    new Date(m8BillRow.paymentDate)
  );

  const statusText = dictionary.statusText(m8BillRow);

  const isIncome =
    m8BillRow.type === 'BY_CARD' || m8BillRow.type === 'CASHLESS';

  return (
    <>
      <SmallTableRowComponent>
        <TextComponent>{dateText}</TextComponent>
        <TextComponent>
          {m8BillRow.type === 'DEBIT' ? (
            <ClickControlComponent onClick={() => onManageBill(m8BillRow.id)}>
              <TextComponent color="accent">{titleText}</TextComponent>
            </ClickControlComponent>
          ) : m8BillRow.type === 'CASHLESS' ? (
            <ClickControlComponent
              onClick={() => onManageGiroPayment(m8BillRow.id)}
            >
              <TextComponent color="accent">{titleText}</TextComponent>
            </ClickControlComponent>
          ) : m8BillRow.type === 'BY_CARD' ? (
            <ClickControlComponent
              onClick={() => onManageCardPayment(m8BillRow.id)}
            >
              <TextComponent color="accent">{titleText}</TextComponent>
            </ClickControlComponent>
          ) : (
            titleText
          )}
          <br />
          {m8BillRow.type === 'REFUND' ? (
            <ClickControlComponent onClick={() => onEditRefund(m8BillRow.id)}>
              <TextComponent color="accent">
                {dictionary.editRefundButtonText}
              </TextComponent>
            </ClickControlComponent>
          ) : m8BillRow.type === 'DEBIT' && m8BillRow.payed === false ? (
            <ClickControlComponent
              onClick={() => setPayDebitConfirmationDialogIsShown(true)}
            >
              <TextComponent color="accent">
                {dictionary.payDebtButtonText}
              </TextComponent>
            </ClickControlComponent>
          ) : (
            statusText
          )}
        </TextComponent>
        <SmallTableExtraComponent>
          <TextComponent color={isIncome ? 'successful' : 'primary'}>
            {primaryAmountText}
          </TextComponent>
        </SmallTableExtraComponent>
      </SmallTableRowComponent>
      <DialogComponent
        open={payDebitConfirmationDialogIsShown}
        title={
          <TextComponent size="mp">
            {dictionary.payDebitConfirmationDialog.title}
          </TextComponent>
        }
        details={
          <ParagraphComponent>
            {dictionary.payDebitConfirmationDialog.message}
          </ParagraphComponent>
        }
        actions={
          <GridContainerComponent axis="x" gap={10}>
            <ModalPressControlComponent
              type="button"
              theme="primary"
              onPress={() => onPayDebit(m8BillRow.id)}
            >
              {dictionary.payDebitConfirmationDialog.confirmButton}
            </ModalPressControlComponent>
            <ModalPressControlComponent
              type="button"
              theme="secondary"
              onPress={() => setPayDebitConfirmationDialogIsShown(false)}
            >
              {dictionary.payDebitConfirmationDialog.cancelButton}
            </ModalPressControlComponent>
          </GridContainerComponent>
        }
      />
    </>
  );
};
